import createSlider from '../../../javascripts/utils/createSlider';
import invisibleFocus from '../../../javascripts/utils/invisibleFocus';

const isDesktop = window.matchMedia('(min-width: 768px)');
const $$careerStage = document.querySelectorAll<HTMLElement>('.career-stage');

$$careerStage.forEach(($careerStage) => {
  const $slides = $careerStage.querySelector<HTMLDivElement>(
    '.career-stage__slides',
  );

  if (
    !$slides ||
    $slides.querySelectorAll('.career-stage__slide').length <= 1
  ) {
    return;
  }

  const slider = createSlider($slides, '.career-stage__slide');

  $careerStage.addEventListener('pager:init', (event) => {
    const { pager } = event.detail;

    slider.onUpdate((currentSlide) => {
      pager.setCurrentPage(currentSlide, false);
    });

    if ($careerStage.hasAttribute('data-autoplay') && isDesktop.matches) {
      pager.start();
    }

    isDesktop.addEventListener('change', (mediaQueryEvent) => {
      if (!mediaQueryEvent.matches) {
        pager.stop();
      }
    });

    let mouseIn = false;
    let focusIn = false;

    $careerStage.addEventListener('mouseenter', () => {
      mouseIn = true;
      pager.pause();
    });

    $careerStage.addEventListener('mouseleave', () => {
      mouseIn = false;
      if (!focusIn) pager.resume();
    });

    $careerStage.addEventListener('focusin', () => {
      focusIn = true;
      pager.pause();
    });

    $careerStage.addEventListener('focusout', () => {
      focusIn = false;
      if (!mouseIn) pager.resume();
    });
  });

  $careerStage.addEventListener('pager:page', (event) => {
    const { currentPage, oldPage, manual } = event.detail;

    slider.moveTo(
      currentPage,
      currentPage < oldPage && manual ? 'prev' : 'next',
    );
  });

  $careerStage
    .querySelector<HTMLButtonElement>('.career-stage__navigation-button--prev')
    ?.addEventListener('click', ({ currentTarget }) => {
      if (currentTarget instanceof HTMLElement) invisibleFocus(currentTarget);
      slider.move('prev');
    });

  $careerStage
    .querySelector('.career-stage__navigation-button--next')
    ?.addEventListener('click', ({ currentTarget }) => {
      if (currentTarget instanceof HTMLElement) invisibleFocus(currentTarget);
      slider.move('next');
    });
});
